import { styled } from '@mui/material/styles'

import { labelWidth } from './common'

const InlineLabel = styled('span')(() => ({
  display: 'inline-block',
  width: labelWidth,
}))

export default InlineLabel
